import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { reloadOnStaleChunk } from './app/reload-on-stale-chunk';
import { startCrossTabAuthSync } from './entities/user';
import './app/styles.css';

// 배포 직후 열려 있던 화면이 지난 빌드 조각을 못 받으면 새로고침해 새 index.html 을 받는다.
reloadOnStaleChunk();

// 다른 탭의 토큰 회전 · 로그아웃을 즉시 반영한다 — 옛 리프레시 토큰으로 재발급을
// 시도하면 서버가 재사용(탈취 의심)으로 판정해 전 세션이 강제 로그아웃된다.
startCrossTabAuthSync();

const container = document.getElementById('root');

if (!container) {
  throw new Error('#root 엘리먼트를 찾을 수 없습니다.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
